<template>
    <div>
        <b-row>
            <b-col sm="12">
                <b-card no-body>
                    <b-card-header>
                        <span class="h5">
                            JOB -
                            <b-badge variant="warning">{{ operacao }}</b-badge>
                            <b-button
                                variant="danger"
                                @click.stop="voltar()"
                                class="float-right btn-sm"
                            >
                                <span>
                                    <i class="fa fa-history"></i> Voltar
                                </span>
                            </b-button>
                            <b-button
                                @click="obterJobLogs()"
                                variant="primary"
                                class="float-right btn-sm mr-2"
                                ><span>
                                    <i class="fa fa-refresh"></i> Atualizar
                                </span></b-button
                            >
                        </span>
                    </b-card-header>
                    <b-card-body>
                        <app-k-v
                            titulo="Job"
                            :md="3"
                            :lg="2"
                            :xl="1"
                            :dado="job.jobId"
                        ></app-k-v>
                        <app-k-v
                            titulo="CRON"
                            :md="3"
                            :lg="2"
                            :xl="1"
                            :dado="job.cron"
                        ></app-k-v>
                        <app-k-v titulo="Status" :md="3" :lg="2" :xl="1"
                            ><app-status :status="job.statusDescr"></app-status
                        ></app-k-v>
                    </b-card-body>
                    <!-- <b-card-footer>
                        <b-button variant="danger" @click.stop="voltar()" class="mr-2">
                            <span>
                                <i class="fa fa-history"></i> Voltar
                            </span>
                        </b-button>
                    </b-card-footer>-->
                </b-card>
            </b-col>
        </b-row>
        <job-logs :jobLogs="jobLogs"></job-logs>
    </div>
</template>

<script>
import JobsServicos from './JobsServicos'
import JobLogs from './JobLogs'

export default {
    components: {
        JobLogs
    },

    props: {
        job: {
            type: Object,
            default: () => {}
        }
    },

    data() {
        return {
            operacao: 'DETALHAR',
            erros: [],
            jobLogs: []
        }
    },

    methods: {
        voltar() {
            this.$router.push({ name: 'Jobs' })
        },

        obterJobLogs() {
            this.$store.dispatch('addRequest')
            JobsServicos.obterLogs(this.job.jobId).then(response => {
                if (response) {
                    if (response.success) {
                        this.jobLogs = response.data
                    } else {
                        this.$toast.error(
                            'Erro ao obter os Jobs',
                            'ERROR',
                            this.$toastConfig.error
                        )
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        }
    },

    computed: {},

    created() {
        this.obterJobLogs()
    },

    watch: {}
}
</script>
